import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	ctaLabel: {
		id: 'subpage.instructorVideo.hero.ctaLabel',
		defaultMessage: 'Play video',
		description: 'A label for the button that plays the video',
	},
});
